import React from 'react';
import _ from 'lodash';
import BottomNavigationMui from '@material-ui/core/BottomNavigation';
import BottomNavigationActionMui from '@material-ui/core/BottomNavigationAction';
import { withStyles } from '@material-ui/core/styles';
import FormatPaintOutlinedIcon from '@material-ui/icons/FormatPaintOutlined';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import { BORDER_RADIUS, UNIT } from '../../constants/theme';
import LoyaltyIcon from '@material-ui/icons/Loyalty';
import Store from '@material-ui/icons/Store';
const BottomNavigation = withStyles({
  root: {
    backgroundColor: '#F1F4F7 !important',
    borderRadius: BORDER_RADIUS
  }
})(BottomNavigationMui);

const BottomNavigationAction = withStyles({
  root: {
    '& .MuiBottomNavigationAction-wrapper': {
      display: 'contents!important'
    }
  },
  iconOnly: {
    padding: UNIT * 0.3125
  },
  selected: {
    color: 'White !important',
    whiteSpace: 'break-spaces',
    fontWeight: 'bold'
  }
})(BottomNavigationActionMui);
const styleIcon = {
  fontSize: UNIT * 1.1875,
  marginRight: UNIT * 0.3125
};
const getBottomNavigationData = (data, loyaltyProgram) => {
  const newData = [];
  _.map(data, e => {
    newData.push({
      label: e,
      icon: !loyaltyProgram ?
        e === 'Config' ? (
          <SettingsOutlinedIcon style={styleIcon} />
        ) : (
          <FormatPaintOutlinedIcon style={styleIcon} />
        ) :
        e === 'Produits' ? (
          <Store style={styleIcon} />
        ) : (
          <LoyaltyIcon style={styleIcon} />
        )
    });
  });
  return newData;
};
const Viewer = ({ value, onChange, style, buttonList, loyaltyProgram }) => {
  const collection = getBottomNavigationData(buttonList, loyaltyProgram);

  return (
    <>
      <BottomNavigation showLabels value={value} onChange={onChange}>
        {_.map(collection, (c, index) => {
          const { label, icon } = c;
          return (
            <BottomNavigationAction
              key={index}
              label={<span style={{ fontSize: UNIT, fontWeight: 'bold' }}>{label}</span>}
              value={index}
              icon={icon}
              style={{
                maxWidth: '100%',
                borderRadius: BORDER_RADIUS,
                backgroundColor: value === index ? `#009973` : '#F1F4F7',
                color: 'black',
                ...style
              }}
            />
          );
        })}
      </BottomNavigation>
    </>
  );
};

export default Viewer;
